import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function Layout() {
  const [cart, setCart] = useState([]);
  const [search, setSearch] = useState("");
  const [showCategory, setShowCategory] = useState(false);
  const [language, setLanguage] = useState("en");

const [notifications, setNotifications] = useState([]);

  return (
    <>
      <Navbar
        search={search}
        setSearch={setSearch}
        showCategory={showCategory}
        setShowCategory={setShowCategory}
        categories={[]}
        setSelectedCategory={() => {}}
        cartCount={cart.length}
        notifications={[]}
        language={language}
        setLanguage={setLanguage}
        notifications={notifications}
        cartCount={
  cart.reduce(
    (total,item)=> total + (item.qty || 1),
    0
  )
}

language={language}

setLanguage={setLanguage}
      />

      <Outlet />

      <Footer />
    </>
  );
}